if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
if (document.querySelector('.fz-new') === null) {
			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}
}
			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
                if(document.querySelector('.fz-max') !== null){
                  document.querySelector('.fz-max').style.display = 'none';
                }
              
				if ( ! qtyMinus.classList.contains('disabled') ) {
					 let currentQty;

                  if (qty.classList.contains('fz-sp')) {
                    currentQty = parseFloat(qty.value.replace(',', '.')) * 10;
                  } else {
                    currentQty = parseInt(qty.value);
                  }
					if ( currentQty - 1 >= qtyMin ) {
                        qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
                      if(document.querySelector('.fz-min') !== null){
                        document.querySelector('.fz-min').style.display = '';
                      }
                        
					}

				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
              if(document.querySelector('.fz-max') !== null){
                document.querySelector('.fz-min').style.display = 'none';
              }
				if ( ! qtyPlus.classList.contains('disabled') ) {
                  let currentQty;

                  if (qty.classList.contains('fz-sp')) {
                    currentQty = parseFloat(qty.value.replace(',', '.')) * 10;
                  } else {
                    currentQty = parseInt(qty.value);
                  }
					
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax && !qty.classList.contains('fz-sp') ) {
						qtyPlus.classList.add('disabled');
                      if(document.querySelector('.fz-max') !== null){
                        document.querySelector('.fz-max').style.display = '';
                      }
					}else if (qty.classList.contains('fz-sp') && currentQty + 1 >= qtyMax) {
                      qty.value = currentQty + 1;
                    }
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}